export default "__VITE_ASSET__D5dgJ5xN__"